module.exports = __webpack_public_path__ + "img/p2ps_3.3897ba66.png";